/* @generated */

// src/assets/ui-icon/line/cursor.tsx
import * as React from "react";
var CursorLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.188 6H11V4.5h1.25c.951 0 1.804.231 2.411.839l.089.093c.029-.031.058-.063.089-.093.607-.608 1.46-.839 2.411-.839h1.25V6h-1.25c-.73 0-1.129.178-1.35.4-.222.221-.4.62-.4 1.35v8c0 .73.178 1.129.4 1.35.221.222.62.4 1.35.4h1.25V19h-1.25c-.951 0-1.804-.231-2.411-.839a2.52 2.52 0 0 1-.089-.093 2.52 2.52 0 0 1-.089.093c-.607.608-1.46.839-2.411.839H11v-1.5h1.25c.73 0 1.129-.178 1.35-.4.222-.221.4-.618.4-1.348V7.75c0-.73-.178-1.129-.4-1.35-.221-.222-.62-.4-1.35-.4h-.063Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 15.5h3V8h-3v1.5h1.5V14H17v1.5Zm-4.5-3H7V11h5.5v1.5Zm0-3h-7V14h7v1.5H4V8h8.5v1.5Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  CursorLine
};
